import React from 'react';
import PropTypes from 'prop-types';
import { withLastLocation } from 'react-router-last-location';
import {
  HorseRacingWeatherModal,
  TjkPlayCouponSuccessModal,
  TjkPlayCouponFailureModal,
  TjkCouponInformationModal,
  MediaPlayerModal,
  CombinationsModal,
  CouponCancelModal,
  CouponCancelFailureModal,
  CouponCancelSuccessModal,
  CouponDeleteModal,
  CouponDeleteFailureModal,
  CouponDeleteSuccessModal,
  CouponRenameModal,
  TjkSaveCouponSuccessModal,
  CouponDetailFailureModal,
  CouponRenameFailureModal,
  CouponIdsCopyModal,
  NotAvaliableFeatureModal
} from './index';
import { resetHRBetSlip, cancelTJKCoupon, toggleHRBetSlip } from 'Store/actions/horseRacing/betSlipActions';
import { useDispatch } from 'react-redux';
import History from 'Store/history';
import { deleteSavedCoupon } from 'Store/actions/horseRacing/couponActions';
import EnvironmentManager from 'Utils/environmentManager';
import Modal from 'Components/Modal';
import LottieLoader from 'Components/LottieLoader';
import { renameSavedCoupon } from 'Store/actions/horseRacing/couponActions';
import MediaPlayerErrorModal from './MediaPlayerModal/MediaPlayerErrorModal';
import { TJK_URL_SUFFIX } from 'Store/constants/horseRacing';
import { resetCouponsPagination } from 'Store/actions/horseRacing/couponActions';
import { openModal } from 'Store/actions';
import { withMixpanel } from 'Utils/mixpanel';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import {
  setCouponsFilter
} from 'Store/actions/horseRacing/couponActions';
import SystemDetail from 'Components/HorseRacing/SystemDetail';

const RenderActiveModals = props => {
  const dispatch = useDispatch();
  const { closeModal, isModalOpen, modalData, mixpanel } = props;

  if (isModalOpen('weatherModal')) {
    return (
      <HorseRacingWeatherModal
        modalClose={ () => {
          closeModal('weatherModal');
        } }
      />
    );
  }

  // BETSLİP MODALS
  if (isModalOpen('tjkPlayCouponSuccessModal')) {
    const { result } = modalData.tjkPlayCouponSuccessModal;
    return (
      <TjkPlayCouponSuccessModal
        result={ result }
        modalClose={ () => {
          closeModal('tjkPlayCouponSuccessModal');
          dispatch(toggleHRBetSlip(false));
          mixpanel.track('Click Action Button on Success Popup in Horse Racing', {
            'Click Action Button': 'X'
          });
        } }
        onPrimaryClick={ () => {
          closeModal('tjkPlayCouponSuccessModal');
          mixpanel.track('Click Action Button on Success Popup in Horse Racing', {
            'Click Action Button': 'Kuponlarima Git'
          });
          dispatch(toggleHRBetSlip(false));
          const filterData = {
            filterName: 'CONTINUED',
            activeTab: 1,
            programType: result?.programType === PROGRAM_TYPES.JOINT ? 1 : 2
          };
          dispatch(setCouponsFilter(filterData));
          History.push(TJK_URL_SUFFIX.coupons.fullPage, { activeTabId: 1 });
          dispatch(resetCouponsPagination(true));
          // dispatch(getContinuedCoupons());
        } }
      />
    );
  }

  // loader
  if (isModalOpen('TJKcouponPlayLoader')) {
    return (
      <Modal
        title="Kuponun Oynanıyor"
        showClose={ false }
        overlayClick={ false }
      >
        <LottieLoader type="loading" loop={ true } autoplay width="38px"/>
      </Modal>
    );
  }

  if (isModalOpen('tjkCouponCancelLoader')) {
    return (
      <Modal
        title="Kuponun İptal Ediliyor"
        showClose={ false }
        overlayClick={ false }
      >
        <LottieLoader type="loading" loop={ true } autoplay width="38px"/>
      </Modal>
    );
  }

  if (isModalOpen('TJKcouponSaveLoader')) {
    return (
      <Modal
        title="Kuponun Kaydediliyor"
        showClose={ false }
        overlayClick={ false }
      >
        <LottieLoader type="loading" loop={ true } autoplay width="38px"/>
      </Modal>
    );
  }

  // BETSLİP MODALS
  if (isModalOpen('TjkSaveCouponSuccessModal')) {
    return (
      <TjkSaveCouponSuccessModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('TjkSaveCouponSuccessModal');
        } }
        onPrimaryClick={ couponName => {
          const fromBetSlip = true;
          if (couponName?.length > 0) {
            const body = {
              couponId: modalData.TjkSaveCouponSuccessModal.couponId,
              name: couponName
            };
            dispatch(renameSavedCoupon(body, fromBetSlip));
          } else {
            closeModal('TjkSaveCouponSuccessModal');
            dispatch(toggleHRBetSlip(true));
          }
        } }
      />
    );
  }

  if (isModalOpen('tjkPlayCouponFailureModal')) {
    const { error, errorTitle } = modalData.tjkPlayCouponFailureModal;
    const errMessage = EnvironmentManager.getMessageText({ key: error.domain + error.code }) || error.message;
    const tjk_max_coupon_total = +EnvironmentManager.getMessageText({ key: 'tjkapp_tjk_max_coupon_total' });
    const tjk_min_coupon_total = +EnvironmentManager.getMessageText({ key: 'tjkapp_tjk_min_coupon_total' });
    if (error.domain + error.code === 'tjk-mobile-bff1003') {
      errMessage.replace('%@', tjk_min_coupon_total);
    } else if (error.domain + error.code === 'tjk-mobile-bff1002') {
      errMessage.replace('%@', tjk_max_coupon_total);
    }

    return (
      <TjkPlayCouponFailureModal
        text={ errMessage }
        errorTitle={ errorTitle }
        errorDomainCode={ error.domain + error.code }
        modalClose={ () => {
          closeModal('tjkPlayCouponFailureModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponInformationModal')) {
    const { successCallback, text } = modalData.tjkCouponInformationModal;
    return (
      <TjkCouponInformationModal
        modalData={ modalData }
        text={ text }
        onPrimaryClick={ () => {
          dispatch(resetHRBetSlip());
          closeModal('tjkCouponInformationModal');
          successCallback();
        } }
        modalClose={ () => {
          closeModal('tjkCouponInformationModal');
        } }
      />
    );
  }

  // MEDIAPLAYER
  if (isModalOpen('tjkMediaPlayerModal')) {
    return (
      <MediaPlayerModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('tjkMediaPlayerModal');
        } }
      />
    );
  }

  // MEDIAPLAYER
  if (isModalOpen('tjkMediaPlayerModalError')) {
    return (
      <MediaPlayerErrorModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('tjkMediaPlayerModalError');
        } }
      />
    );
  }

  // COUPONS MODALS
  if (isModalOpen('combinationsModal')) {
    return (
      <CombinationsModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('combinationsModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponCancelModal')) {
    return (
      <CouponCancelModal
        modalData={ modalData }
        onPrimaryClick={ () => {
          dispatch(cancelTJKCoupon(modalData.tjkCouponCancelModal));
          closeModal('tjkCouponCancelModal');
          dispatch(openModal('tjkCouponCancelLoader'));
          modalData.tjkCouponCancelModal.triggerMixpanel();
        } }
        modalClose={ () => {
          closeModal('tjkCouponCancelLoader');
          closeModal('tjkCouponCancelModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponCancelFailureModal')) {
    return (
      <CouponCancelFailureModal
        onPrimaryClick={ () => {
          closeModal('tjkCouponCancelFailureModal');
          History.push(TJK_URL_SUFFIX.coupons.fullPage);
        } }
        modalClose={ () => {
          closeModal('tjkCouponCancelFailureModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponCancelSuccessModal')) {
    return (
      <CouponCancelSuccessModal
        onPrimaryClick={ () => {
          closeModal('tjkCouponCancelSuccessModal');
          History.push(TJK_URL_SUFFIX.program.fullPage);

        } }
        modalClose={ () => {
          closeModal('tjkCouponCancelSuccessModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponDeleteModal')) {
    return (
      <CouponDeleteModal
        modalData={ modalData }
        onPrimaryClick={ () => {
          dispatch(deleteSavedCoupon(modalData.tjkCouponDeleteModal));
          closeModal('tjkCouponDeleteModal');
        } }
        modalClose={ () => {
          closeModal('tjkCouponDeleteModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponDeleteFailureModal')) {
    return (
      <CouponDeleteFailureModal
        onPrimaryClick={ () => {
          closeModal('tjkCouponDeleteFailureModal');
          History.push(TJK_URL_SUFFIX.coupons.fullPage);
        } }
        modalClose={ () => {
          closeModal('tjkCouponDeleteFailureModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponDeleteSuccessModal')) {
    return (
      <CouponDeleteSuccessModal
        onPrimaryClick={ () => {
          closeModal('tjkCouponDeleteSuccessModal');
          History.push(TJK_URL_SUFFIX.program.fullPage);

        } }
        modalClose={ () => {
          closeModal('tjkCouponDeleteSuccessModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponRenameModal')) {
    return (
      <CouponRenameModal
        modalData={ modalData }
        onPrimaryClick={ couponName => {
          const fromBetSlip = false;
          const body = {
            couponId: modalData.tjkCouponRenameModal.couponId,
            name: couponName
          };
          dispatch(renameSavedCoupon(body, fromBetSlip));
        } }
        modalClose={ () => {
          closeModal('tjkCouponRenameModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponRenameFailureModal')) {
    return (
      <CouponRenameFailureModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('tjkCouponRenameFailureModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponDetailFailureModal')) {
    return (
      <CouponDetailFailureModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('tjkCouponDetailFailureModal');
          // dispatch(getContinuedCoupons());
          History.push(TJK_URL_SUFFIX.coupons.fullPage);
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponIdsCopyModal')) {
    return (
      <CouponIdsCopyModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('tjkCouponIdsCopyModal');
        } }
      />
    );
  }

  if (isModalOpen('tjkCouponPlayFailureModal')) {
    return (
      <CouponDetailFailureModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('tjkCouponPlayFailureModal');
        } }
      />
    );
  }

  if (isModalOpen('notAvaliableFeatureModal')) {
    return (
      <NotAvaliableFeatureModal
        modalData={ modalData }
        modalClose={ () => {
          closeModal('notAvaliableFeatureModal');
        } }
      />
    );
  }

  if (isModalOpen('systemDetailModal')) {
    return (
      <SystemDetail
        onCLose={ () => {
          closeModal('systemDetailModal');
        } }
      />
    );
  }

  return null;
};

RenderActiveModals.propTypes = {
  closeModal: PropTypes.func,
  openModal: PropTypes.func,
  isModalOpen: PropTypes.func,
  modalData: PropTypes.object,
  mixpanel: PropTypes.object
};

export default withLastLocation(withMixpanel(RenderActiveModals));
